var REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export var validations = {
  required: function required(message) {
    return {
      value: true,
      message: message
    };
  },
  maxLength: function maxLength(message) {
    return {
      value: 50,
      message: message
    };
  },
  minLength: function minLength(message) {
    return {
      value: 6,
      message: message
    };
  },
  email: function email(message) {
    return {
      value: REGEX_EMAIL,
      message: message
    };
  }
};
export var EVENTS = {
  REGISTER: 'AUTH__REGISTER',
  LOGIN: 'AUTH__LOGIN',
  AUTH_SOCIAL: 'auth_social',
  SIGNUP_FORM_BUTTON_CLICK: 'Click Signup Button'
};